<template>

<div class="head" :class="{'is-simple': simple}">

	<app-page-inner class="head-inner">

        <router-link :to="{path: '/'}" class="head-logo" v-if="!simple || window.is.mobile" />
        <div v-if="simple" />

        <div class="head-menu" v-if="!window.is.mobile || expanded">

            <router-link :to="{path: '/' }" class="head-menu-item" key="home">Home</router-link>

            <router-link :to="{path: '/' + page.url}" :target="target" class="head-menu-item" v-for="(page, index) in pages.other" :key="index">{{ page.title }}</router-link>

        </div>

        <div class="head-toggle" v-on:click="onMenuClick" v-if="window.is.mobile">

            <div></div><div></div><div></div>

        </div>

	</app-page-inner>

</div>

</template>

<script>

export default {

    props: ['simple'],

    data: function() {

        return {
            expanded: false
        }

    },

    computed: {

        path: function() {

            return this.$route.path

        },

        target: function() {

            return (this.simple) ? '_blank' : false

        }

    },

    watch: {

        path: function() {

            this.expanded = false

        }

    },

    methods: {

        onMenuClick: function() {

            this.expanded = !this.expanded

        }

    }

}

</script>

<style scoped>

.head {
    height: 82px;
    z-index: 1000;
}

.is-mobile .is-dark .head {
    display: none;
}

.is-mobile .head {
    height: 64px;
}

.head.is-simple {
    position: absolute;
    width: 100%;
    max-width: 1200px;
}

.head-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 82px;
}

.is-mobile .head-inner {
    height: 64px;
}

.head-logo {
    background-image: url(~@/assets/logo.new.svg);
    width: 242px;
    height: 50px;
}

.is-mobile .head-logo {
    background-size: contain;
    height: 40px;
    background-repeat: no-repeat;
    background-position: 15px 0px;
}

.head-menu {
    display: flex;
    padding-right: 100px;
    gap: 30px;
}

.head.is-simple .head-menu {
    padding-right: 160px;
}

.is-mobile .head-menu {
    position: fixed;
    flex-direction: column;
    left: 0px;
    top: 64px;
    bottom: 0px;
    right: 0px;
    background-color: #fff;
    padding: 30px 20px;
    gap: 0px;
}

.head-menu-item {
    font-size: 14px;
    font-weight: bold;
    color: #343434;
}

.is-mobile .head-menu-item {
    height: 40px;
    line-height: 40px;
}

.head-menu-item:hover {
    text-decoration: underline;
}

.head-menu-item.router-link-exact-active {
    color: #23CFFD;
}

.is-patient .head-menu-item.router-link-exact-active {
    color: #F69B3B;
}

.head-toggle {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 10px;
    right: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.head-toggle div {
    background-color: #999;
    height: 4px;
    width: 24px;
    border-radius: 4px;
}

</style>